module.exports = __webpack_public_path__ + "img/retail06.2bad0ae9.png";